import React, { useRef } from 'react'
import ChipPopover from './ChipPopover'
import FlowApplications from './FlowApplications'
import { chipPopoverLabel, licenseIncludes } from './layoutBuilderCopy'

// A curated flow-type chip. Clicking it asks its parent to toggle a detail popover (open/onToggle/
// onClose are controlled, so the parent keeps one popover open at a time). The popover describes
// each underlying catalog flow of this integration: its real name, description, own license count
// and applications (see ChipPopover for how it is positioned and dismissed).
export default function FlowNameChip ({ label, flows, applications, isSelected, open, onToggle, onClose }) {
  const chipRef = useRef(null)

  return (
    <>
      <button
        type='button'
        ref={chipRef}
        className={`layoutBuilder-flowfirst-chip ${isSelected ? 'is-selected-chip' : ''}`.trim()}
        aria-expanded={open}
        aria-haspopup='dialog'
        onClick={event => {
          event.stopPropagation()
          onToggle()
        }}
      >
        <span className='layoutBuilder-flowfirst-chip-label'>{label}</span>
      </button>
      <ChipPopover anchorRef={chipRef} open={open} onClose={onClose} ariaLabel={chipPopoverLabel(label)} title={label}>
        {flows.map(flow => (
          <section className='layoutBuilder-chip-popover-flow' role='group' aria-label={flow.name} key={flow.id}>
            <strong>{flow.name}</strong>
            {flow.description && <p className='layoutBuilder-chip-popover-description'>{flow.description}</p>}
            {Number.isFinite(flow.max_flows) && <p className='layoutBuilder-chip-popover-limit'>{licenseIncludes(flow.max_flows)}</p>}
            <FlowApplications flow={flow} applications={applications} />
          </section>
        ))}
      </ChipPopover>
    </>
  )
}
